module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS13.26985ff8.jpg";